import { createError } from '../utils/background/Utils';

const AlreadyStartedError = createError({
    name: 'AlreadyStartedError',
    message: 'Audio system info connection already started'
});

export const SysInfoConn = {
    AlreadyStartedError
};
